import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { grey } from '@material-ui/core/colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100vh',
      flexWrap: 'nowrap',
      backgroundColor: 'white',
      fontFamily: 'Montserrat, sans-serif',
    },
    leftPanel: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'center',
      padding: theme.spacing(0, 12),
      backgroundColor: 'white',
      zIndex: 10,
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0, 4),
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: '50%',
      },
      marginTop: theme.spacing(12),
    },
    formContainer: {
      width: '100%',
      maxWidth: 420,
      marginLeft: 'auto',
      [theme.breakpoints.down('md')]: {
        margin: '0 auto',
      },
    },
    logoSection: {
      display: 'flex',
      alignItems: 'flex-start',
      // marginBottom: theme.spacing(12),
      height: '100%',
    },
    logo: {
      marginRight: theme.spacing(1.5),
    },
    brandText: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: 1,
      fontFamily: 'Montserrat',
      '& span:first-child': {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: '#111827',
        letterSpacing: '-0.025em',
        marginTop: 3
      },
      '& span:last-child': {
        fontSize: '1.75rem',
        fontWeight: 800,
        color: '#111827',
      },
    },
    welcomeTitle: {
      fontSize: 32,
      fontWeight: 500,
      color: '#111827',
      marginBottom: theme.spacing(4),
      textAlign: 'center',
      fontFamily: 'Montserrat',
      letterSpacing: '-0.025em',
    },
    submit: {
      width: '100%',
      padding: theme.spacing(1.75, 4),
      backgroundColor: '#F37E57',
      color: 'white',
      borderRadius: 12,
      border: 'none',
      textTransform: 'none',
      fontSize: '0.875rem',
      fontWeight: 600,
      boxShadow: '0 1px 2px 0 #ffffff0d',
      '&:hover': {
        backgroundColor: '#e26d46',
      },
    },
    linkSection: {
      marginTop: theme.spacing(5),
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2.5),
    },
    linkText: {
      fontSize: 13,
      color: '#4B5563',
      '& button': {
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#111827',
        '&:hover': {
          color: 'black',
        },
      },
      '& a': {
        textDecoration: 'none',
        fontWeight: 600,
        color: '#4B5563',
        '&:hover': {
          color: 'black',
        },
      },
    },
    rightPanel: {
      display: 'none',
      [theme.breakpoints.up('lg')]: {
        display: 'block',
        flex: 1,
        position: 'relative',
        backgroundColor: 'white',
        overflow: 'hidden',
      },
    },
    rightInner: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(4),
    },
    bgCard: {
      position: 'relative',
      width: 462,
      height: 809,
      maxWidth: 'full',
      maxHeight: '90vh',
      backgroundColor: '#FFE8C7',
      borderRadius: 30,
      transform: 'scale(0.85)',
    },
    heroImageContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      top: 40,
      right: 40,
    },
    heroImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 30,
    },
  }),
)

export default useStyles
